import React, { useContext } from 'react';
import NotificationContext from '../../../services/NotificationContext';
import BannerNotification from './BannerNotification';

const BannerNotifications = () => {
  const { banners, readOne, deleteOne } = useContext(NotificationContext);
  let allBanners = null;
  if (banners) {
    allBanners = banners.map(function(banner) {
      return (
        <BannerNotification
          key={banner.id}
          id={banner.id}
          readOne={readOne}
          html={banner.text}
          removable={banner.removable}
          deleteOne={deleteOne}
        />
      );
    });
  }
  return allBanners;
};

export default BannerNotifications;
